import "./ComicNav.css";

import {Link, useParams} from "react-router-dom";

import ComicList from "../ComicList";
import {useSelector} from "react-redux";

function importAll(r) {
  let images = {};
  r.keys().forEach(item => { images[item] = r(item); });
  return images;
}

const images = {
  'hoh': importAll(require.context('../images/comic_nav/hoh/', false, /\.png/)),
  'aptgg': importAll(require.context('../images/comic_nav/aptgg/', false, /\.png/)),
};

function ComicNav({char = "", story}) {
  const {comic} = useParams();
  const comics = useSelector(state => state.stories.comics[story]);
  const comicList = new ComicList(comics);

  char = char.toLowerCase();
  const charSuffix = char ? `_${char}` : '';

  const prev = './../' + comicList.prevComic(comic, char);
  const next = './../' + comicList.nextComic(comic, char);
  const first = './../' + comicList.firstComic(char);

  return (
    <div className={`comic_nav char${charSuffix} comic_${story}`}>
      <ul>
        <li className="prev">
          <Link to={prev}>
            <img src={images[story][`./prev${charSuffix}.png`]} alt='Previous comic' />
          </Link>
        </li>
        <li className="first">
          <Link to={first}>
            <img src={images[story][`./first${charSuffix}.png`]} alt='First comic' />
          </Link>
        </li>
        
        <li className='archive'>
          <Link to={`./../archive`}>
            <img src={images[story][`./archive${charSuffix}.png`]} alt='Archive' />
          </Link>
        </li>
        <li className="latest">
          <Link to={'./../latest'}>
            <img src={images[story][`./last${charSuffix}.png`]} alt='Latest comic' />
          </Link>
        </li>
        <li className="next">
          <Link to={next}>
            <img src={images[story][`./next${charSuffix}.png`]} alt='Next comic' />
          </Link>
        </li>
      </ul>
    </div>
  );
}

export default ComicNav;